import Map from "../map/Map";
import { getPopup } from "./popup";

class ItineraryMap {
  constructor(DOMelement, store) {
    try {
      this.el = DOMelement;
      this.store = store;    
      this.mapEl = this.el.querySelector('[id^="itinerary-sd-map"]');
  
      this.closeAllPopUps = this.closeAllPopUps.bind(this);
      this.onMarkerClick = this.onMarkerClick.bind(this);
      this.map = new Map(this.mapEl, store, this.onMarkerClick);

      this.data_geo_attr = this.mapEl.getAttribute("data-geo");
      this.scriptID = document.querySelector(`#${this.data_geo_attr}`);    
      this.scriptData = this.scriptID.innerText;
      this.mapData = JSON.parse(this.scriptData);
    } catch (error) {
      console.log(error);
    }
  }

  closeAllPopUps() {
    if (this.map.popUps.length) {
      this.map.popUps.forEach((item) => item.remove());
    }
  }

  onMarkerClick(data, idx) {
    this.closeAllPopUps();
    const popupHtml = getPopup(data);
    const popup = new this.map.mapbox.Popup({ closeOnClick: false })
      .setLngLat([data.longitude, data.latitude])
      .setHTML(popupHtml);
    this.map.popUps.push(popup);
    popup.addTo(this.map.map);
    this.map.map.flyTo({
      center: [data.longitude, data.latitude],
      essential: true,
    });
  }



}

export default ItineraryMap;
